<template>
  <div class="container" id="Courses">
    <div class="page-header gold my-4">
      <back-btn to="/dashboard" position="relative" class="mr-auto"></back-btn>
      <h3 class="mb-0 flex-grow-1"><span v-text="page_title"></span></h3>
    </div>

    <div v-if="page_loaded == 0" class="text-center mt-5 gold">
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <p>Loading...</p>
    </div>
    <div v-else>

      <div class="mb-4" v-for="course in courses" :key="course.id">
        <div class="row pb-3 mb-3">
          <div class="col-12" v-html="course.description"></div>
          <div class="col-12 pt-2">
            <b-progress
              :value="course.user.percent"
              max="100"
              height="10px"
              :variant="setBarColour(course.user.percent)"
            ></b-progress>
          </div>
        </div>

        <div class="">
          <b-list-group v-for="section in course.sections" :key="section.id">
            <b-list-group-item class="mb-2">
              <h5 :class="{ gold: section.user.percent === 100 || section.user.complete === 1 }">
                <i v-if="section.user.percent === 100 || section.user.complete === 1" class="fas fa-check pr-2"></i>
                <span v-text="section.title"></span>:
                <small v-text="section.sub_title"></small>
              </h5>
              <div class="row">
                <div class="col-md-9">
                  <span v-html="section.description"></span>
                </div>
                <div class="col-md-3 text-center p-2">
                  <b-button
                    v-if="section.user.percent < 100 || section.user.complete === 0"
                    @click="startSection(section, course)"
                    variant="primary"
                  >
                    <i class="far fa-hand-point-right"></i> Take Section
                  </b-button>
                  <p v-else>
                    <small>Section Completed</small><br />
                    <b v-text="section.user.date" class="gold"></b><br />
                    <b-button @click="startSection(section, course)">
                      <i class="far fa-thumbs-up"></i> Re-Take Section
                    </b-button>
                  </p>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </div>

    <b-modal id="course_modal" size="lg" hide-footer hide-header no-close-on-backdrop>
      <CourseMeditation :data="modal" modal_id="course_modal" />
    </b-modal>
  </div>
</template>

<script>
import axios from '@/axios';
import CourseMeditation from '../components/CourseMeditation.vue';
import BackBtn from "@/components/BackBtn.vue";

export default {
  name: 'Courses',
  components: {
    BackBtn,
    CourseMeditation,
  },

  data() {
    return {
      courses: {},
      modal: {},
      page_loaded: 0,
      page_title: this.$route.meta.title,
    };
  },

  methods: {
    courseGet() {
      let _this = this;

      axios({
        method: 'post',
        url:  'coursesGet',
        data: {
          course_id: _this.$route.params.id,
        },
      })
        .then(function (response) {
          _this.courses = response.data.courses;
          _this.page_loaded = 1;

          const obj = Object.values(_this.courses);
          for (const item of obj) {
            if (parseInt(item.id) === parseInt(_this.$route.params.id)) {
              _this.page_title = item.title;
              document.title = _this.page_title + ' - Course - iAMconnected App';
            }
          }
        })
        .catch(function (e) {
          console.log('Error: courseGet:' + e);
        });
    },
    hideModal() {
      this.$bvModal.hide('course_modal');
    },
    setBarColour(val) {
      var C = 'white_bgd';
      if (val >= 100) {
        C = 'gold_bgd';
      } else if (val >= 40) {
        C = 'cl_bg_blue';
      } else if (val > 0) {
        C = 'bronze_bgd';
      }
      return C;
    },

    startSection(section, course) {
      this.modal = section;
      this.modal.type = course.type ? course.type : null;
      this.$bvModal.show('course_modal');
    },
  },

  created() {
    this.courseGet()
  },

  computed: {
    profile() {
      return this.$store.getters.profileGet;
    },
  }
};
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 14px;
  position: relative;
}

</style>
